import styled from 'styled-components';

/**
 * ContentWrapper
 *
 * A reusable wrapper component for content inside Card components.
 * Provides consistent padding and responsive behavior.
 *
 * Usage:
 * import ContentWrapper from 'components/ContentWrapper';
 *
 * <Card noPadding>
 *   <ContentWrapper>
 *     {content}
 *   </ContentWrapper>
 * </Card>
 */

const ContentWrapper = styled.div`
  padding: ${(props) => props.padding || '32px'};
  font-family: Arial, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Ubuntu, sans-serif;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    padding: ${(props) => props.mobilePadding || '16px'};
  }
`;

export default ContentWrapper;
